import React from "react";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import Header from "@shared/components/Header";
import Loader from "@shared/components/Loader";
import Footer from "@shared/components/Footer";
import Main from "@shared/components/Main";
import TermsAndConditions from "@shared/components/TermsAndConditions";
import { useData } from "@shared/context/Data";
import styles from "@shared/styles/app.styles.css";
const logo = require("../../assets/logo1024.png");
function HeaderWithIntl() {
    const intl = useIntl();
    return (React.createElement(Header, { link: PAGE_PATH, logoSrc: logo, logoAlt: intl.formatMessage({ id: "LogoAltText" }), mainTitle: React.createElement(FormattedMessage, { id: "MainTitle", values: { city: CITY_NAME } }) }));
}
function App() {
    const { messages, language, isLoading } = useData();
    return (React.createElement(IntlProvider, { locale: language, messages: messages }, isLoading
        ? React.createElement(Loader, null)
        : (React.createElement("div", { className: styles.container },
            React.createElement(HeaderWithIntl, null),
            React.createElement(Main, null,
                React.createElement(TermsAndConditions, { city: CITY_NAME })),
            React.createElement(Footer, null)))));
}
export default App;
